import {
    sponsorApplicationList,
    sponsorApplicationByID,
} from '@/services/agency/showcaseSponsorApplications.service'

export default {
    namespaced: true,
    state: {
        sponsorApplicationList: { meta: { pagination: { total: 0 } } },
        sponsorApplication: {},
        sponsorApplicationStatus: 'pending',
    },
    getters: {
        getSponsorApplicationList(state) { return state.sponsorApplicationList },
        getSponsorApplication(state) { return state.sponsorApplication },
        getSponsorApplicationStatus(state) { return state.sponsorApplicationStatus },
    },
    mutations: {
        SPONSOR_APPLICATION_LIST(state, value) { state.sponsorApplicationList = value },
        SET_SPONSOR_APPLICATION(state, value) { state.sponsorApplication = value },
        SPONSOR_APPLICATION_STATUS(state, value) { state.sponsorApplicationStatus = value },
    },
    actions: {
        async fetchSponsorApplicationList({ commit }, params) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
            commit('SPONSOR_APPLICATION_STATUS', 'pending')
            commit('SPONSOR_APPLICATION_LIST', { meta: { pagination: { total: 0 } } })
            try {
                const { data } = await sponsorApplicationList(params)
                commit('SPONSOR_APPLICATION_STATUS', 'init')
                commit('SPONSOR_APPLICATION_LIST', data)
                return data
            } catch (error) {
                commit('SPONSOR_APPLICATION_STATUS', 'init')
                throw error
            }
        },
        async fetchSponsorApplicationByID({ commit }, params) {
            commit('SPONSOR_APPLICATION_STATUS', 'pending')
            try {
                const { data } = await sponsorApplicationByID(params)
                commit('SPONSOR_APPLICATION_STATUS', 'init')
                commit('SET_SPONSOR_APPLICATION', data.data)
                return data
            } catch (error) {
                commit('SPONSOR_APPLICATION_STATUS', 'init')
                return error
            }
        },
    },
}
